import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, retry, Subject, Subscription } from 'rxjs';
import { ApiServicesService } from './api-services.service';
import { SnackbarService } from './snackbar.service';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {

  ngOnInit() {
    this.allPosts.next('');
  }

  page_no = new BehaviorSubject<number>(0);
  pge = this.page_no.asObservable();
  private isCompleted = false;
  constructor(
    private apiService: ApiServicesService,
    private snackbarService: SnackbarService,
  ) { }

  is_userdetails = new BehaviorSubject<any>('');
  userdetails$ = this.is_userdetails.asObservable();

  userdata = this.userdetails$

  refreshPhotos = new BehaviorSubject<any>('');
  photos$ = this.refreshPhotos.asObservable();

  allPosts = new BehaviorSubject<any>('');
  posts$ = this.allPosts.asObservable();

  dropDownData = new BehaviorSubject<any>('');
  dropDownData$ = this.dropDownData.asObservable();

  formData = new BehaviorSubject<any>('');
  formData$ = this.formData.asObservable();


  headerUpdateSource = new Subject<void>();
  headerUpdate$ = this.headerUpdateSource.asObservable();


  friendsCount = new BehaviorSubject<any>('');
  friendsCount$ = this.friendsCount.asObservable();

  messageCount = new BehaviorSubject<any>('');
  messageCount$ = this.messageCount.asObservable();


  triggerHeaderUpdate() {
    this.headerUpdateSource.next();
  }

  getAllPost(userId: any, page: any, limit: any) {
    this.apiService.getAllPost(userId, page, limit).subscribe({
      next: (response) => {
        this.allPosts.next(response);
        if(response.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: response.message,
              className: 'failed',
            }
          );
        }
      },
      error: (err) => {
        this.allPosts.next({ error: err.error.message });
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    })
  }

  isRequestPending: boolean = false;

  getAllPostActivity(page: any, limit: any) {
    if (this.isRequestPending) {
      return;
    }
    this.isRequestPending = true;
    this.allPosts.next('');
    this.apiService.getAllPostActivity(page, limit).pipe(
      retry(1)
    ).subscribe({
      next: (response) => {
        this.allPosts.next(response);
        if(response.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: response.message,
              className: 'failed',
            }
          );
        }
      },
      error: (err) => {
        this.allPosts.next({ error: err.error.message });

        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      },
      complete: () => {
        this.isRequestPending = false;
      },
    });
  }


  getAllPostActivityScroll(page: any, limit: any) {
    this.allPosts.next('');
    return this.apiService.getAllPostActivity(page, limit);
  }

  Gotuserdetails(userdetails: any) {
    this.is_userdetails.next(userdetails);
  }

  ReinitializeUserDetails() {
    this.is_userdetails = new BehaviorSubject<any>(null);
    this.userdetails$ = this.is_userdetails.asObservable();
    this.isCompleted = false;
  }

  setPageno(page: number) {
    this.page_no.next(page);
  }

  ngOnDestroy(): void {
    this.is_userdetails.complete();
    this.isCompleted = true;
  }

  clearUserDetails(): void {
    this.is_userdetails.next(null);
  }

  setFormData(formdata:any):void{
    this.formData.next(formdata)
  }


  setFriendsCount(count:any):void{
    this.friendsCount.next(count)
  }


  setMessageCount(count:any):void{
    this.messageCount.next(count)
  }

}

